import { DialogProps } from '@radix-ui/react-dialog';
import { Dialog } from 'components/dialog';
import styles from './IppicaFiltersDialog.module.scss';

export type IppicaFiltersDialogProps = DialogProps & {
  title?: string;
  className?: string;
  children?: React.ReactNode;
};

export const IppicaFiltersDialog = ({ title, children, ...props }: IppicaFiltersDialogProps) => {
  return (
    <Dialog
      {...props}
      open={props.open}
      onOpenChange={props.onOpenChange}
      isMobileFullScreen
      dialogTitle={title}
      hasClickOutside
      contentClassName={`${styles.container} ${props.className ? props.className : ''}`}
      hasHighlightedTitle
    >
      {children}
    </Dialog>
  );
};
